import { AutoMap } from "@automapper/classes";

export class ContractDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    name!: String;
}